<div class="eod-input">
  <!-- <label for="searchText">{{"label_search_criterion" | translate}}</label>
  <div class="--is-icon icon-right">
    <input
      id="searchText"
      type="text"
      class="form-control"
      #searchField
      name="searchText"
      [(ngModel)]="searchText"
    />
    <span class="input-icon right"><img [src]="ICONS.SEARCH" alt="toggle" /></span>
  </div> -->
  <div>
    <ds-textbox #searchField [(ngModel)]="searchText" [textboxInput]="textboxConfig"></ds-textbox>
  </div>
</div>
<ul class="bulkList">
  @for (item of dateFormats | grdFilter : { value: searchText } : false; track item) {<li
    class="f-14 border-bottom padding-bottom-10" [ngClass]="{ active: item == formControl.value }"
    (click)="fnSetDateFormat(item.value)">
    <span class="d-inline-block">
      {{ item.value }}
    </span>
  </li>}
</ul>